var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavbarEventOff = function SvgNavbarEventOff(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "M21 5.25h-7.447l2.69-2.69-1.06-1.06L12 4.682 8.818 1.5l-1.06 1.06 2.689 2.69H1.5V12h2.25v7.5a3 3 0 0 0 3 3h13.5V12h2.25V5.25zM12.75 21h6v-9h-6zm-7.5-9v6.75A2.25 2.25 0 0 0 7.5 21h3.75v-9zm7.5-1.5V6.75H21v3.75h-8.25m-1.5 0H3V6.75h8.25z",
    clipRule: "evenodd"
  })));
};
export default SvgNavbarEventOff;